module.exports = __webpack_public_path__ + "media/images/opioid-hospitalizations-c50a6f641de59c3051cf1e50e146a989.png";